import { Component, OnInit } from '@angular/core';
import { InstructorService } from 'src/app/service/instructor.service';
import { Instructor } from 'src/app/model/instructor.model';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-instructor-list',
  templateUrl: './instructor-list.component.html',
  styleUrls: ['./instructor-list.component.css']
})
export class InstructorListComponent implements OnInit {
  instructors: Instructor[];
  filteredInstructors: Instructor[];
  filterName = '';
  filterStartDate: Date;
  filterEndDate: Date;

  constructor(private instructorService: InstructorService, private router: Router, private datePipe: DatePipe) {}

  ngOnInit() {
    this.instructorService.getAll().subscribe(data => {
      this.instructors = data as Instructor[];
      this.filteredInstructors = data as Instructor[];
    });
  }

  filterInstructors() {
    this.filteredInstructors = this.instructors.filter(
      i => this.instructorNameContains(this.filterName, i));
  }

  instructorNameContains(namePart: string, instructor: Instructor): boolean {
    return namePart.trim() === '' || (instructor.user.name + instructor.user.lastName).toLowerCase().includes(namePart.toLowerCase());
  }

  instructorIsAveiableInPeriod(start: Date, end: Date, instructor: Instructor): boolean {
    return instructor.dateSlotsAvailable.filter(d =>
        start == null ||
        end == null ||
        (new Date(d.start).setHours(0, 0, 0, 0) <= start.setHours(0, 0, 0, 0) && end.setHours(0, 0, 0, 0) <= new Date(d.end).setHours(0, 0, 0, 0))
      ).length > 0;
  }

  compareDates(smaller: Date, bigger: Date): boolean {
    return smaller.setHours(0, 0, 0, 0) <= bigger.setHours(0, 0, 0, 0);
  }

  clearfilterStartDate() {
    this.filterStartDate = undefined;
    this.filterInstructors();
  }

  clearfilterEndDate() {
    this.filterEndDate = undefined;
    this.filterInstructors();
  }

  onInstructorDeleted($event: any) {
    this.instructorService.getAll().subscribe(data => {
      this.instructors = data as Instructor[];
      this.filterInstructors();
    });
  }

  add() {
    this.router.navigateByUrl('/instructor-edit/0');
  }
}
